import { useState, useCallback } from 'react'

export function useDarkMode() {
  const [isDark, setIsDark] = useState<boolean>(
    () => !document.documentElement.classList.contains('light')
  )

  const toggle = useCallback(() => {
    const html = document.documentElement
    if (isDark) {
      html.classList.remove('dark')
      html.classList.add('light')
      localStorage.setItem('dd-theme', 'light')
      setIsDark(false)
    } else {
      html.classList.remove('light')
      html.classList.add('dark')
      localStorage.setItem('dd-theme', 'dark')
      setIsDark(true)
    }
  }, [isDark])

  return { isDark, toggle }
}
